import React from 'react'
import { Outlet } from 'react-router-dom'
import BrandMark from '@/components/BrandMark'

/**
 * Auth shell — HealthyCoach design system: flat canvas, logo top-left, one centred 452px column.
 * Each auth page renders its own <AuthCard> plus the secondary link that sits below it.
 */
const AuthLayout = () => (
  <div className="flex min-h-screen flex-col bg-background">
    <header className="flex items-center gap-2 px-6 pt-6 sm:px-8 sm:pt-8">
      <BrandMark size={22} />
      <span className="text-sm font-semibold tracking-[-0.01em] text-slate-900">HealthyCoach</span>
    </header>

    <main className="flex flex-1 items-center justify-center px-4 py-10">
      <div className="w-full max-w-[452px]">
        <Outlet />
      </div>
    </main>
  </div>
)

export default AuthLayout
